/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { CspSubAccount } from "./CspSubAccount";
import {
  CspSubAccountFromJSON,
  CspSubAccountFromJSONTyped,
  CspSubAccountToJSON,
  CspSubAccountToJSONTyped,
} from "./CspSubAccount";
import type { CustomerSpecificPricingAgreementStatus } from "./CustomerSpecificPricingAgreementStatus";
import {
  CustomerSpecificPricingAgreementStatusFromJSON,
  CustomerSpecificPricingAgreementStatusFromJSONTyped,
  CustomerSpecificPricingAgreementStatusToJSON,
  CustomerSpecificPricingAgreementStatusToJSONTyped,
} from "./CustomerSpecificPricingAgreementStatus";

/**
 *
 * @export
 * @interface CustomerSpecificPricingAgreement
 */
export interface CustomerSpecificPricingAgreement {
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  customerSpecificPricingAgreementId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  createdAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  frontConversationId?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  carrierIdentifier?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  serviceIdentifier?: string;
  /**
   *
   * @type {CustomerSpecificPricingAgreementStatus}
   * @memberof CustomerSpecificPricingAgreement
   */
  status?: CustomerSpecificPricingAgreementStatus;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  accountName?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  accountNumber?: string;
  /**
   *
   * @type {LocalDate}
   * @memberof CustomerSpecificPricingAgreement
   */
  pricingExpiryDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof CustomerSpecificPricingAgreement
   */
  proposalSentDate?: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof CustomerSpecificPricingAgreement
   */
  activationDate?: LocalDate;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  assignedAdmin?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  apiToken?: string;
  /**
   *
   * @type {boolean}
   * @memberof CustomerSpecificPricingAgreement
   */
  requiresRateSheet?: boolean;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  username?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  cancellationReason?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof CustomerSpecificPricingAgreement
   */
  postalCodeWhitelist?: Array<string>;
  /**
   *
   * @type {ConversationTurn}
   * @memberof CustomerSpecificPricingAgreement
   */
  carrierTurn?: ConversationTurn;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  carrierTurnTime?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  proposalSentAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  activatedAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  cancelledAt?: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  draftedAt?: OffsetDateTime;
  /**
   *
   * @type {boolean}
   * @memberof CustomerSpecificPricingAgreement
   */
  useBlanketRates?: boolean;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  declineReason?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  declinedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  notes?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  existingCustomerAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CustomerSpecificPricingAgreement
   */
  existingCustomerReason?: string;
  /**
   *
   * @type {Array<CspSubAccount>}
   * @memberof CustomerSpecificPricingAgreement
   */
  subAccounts?: Array<CspSubAccount>;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CustomerSpecificPricingAgreement
   */
  finalizingAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CustomerSpecificPricingAgreement interface.
 */
export function instanceOfCustomerSpecificPricingAgreement(
  value: object,
): value is CustomerSpecificPricingAgreement {
  return true;
}

export function CustomerSpecificPricingAgreementFromJSON(
  json: any,
): CustomerSpecificPricingAgreement {
  return CustomerSpecificPricingAgreementFromJSONTyped(json, false);
}

export function CustomerSpecificPricingAgreementFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingAgreement {
  if (json == null) {
    return json;
  }
  return {
    customerSpecificPricingAgreementId:
      json["customerSpecificPricingAgreementId"] == null
        ? undefined
        : json["customerSpecificPricingAgreementId"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    frontConversationId:
      json["frontConversationId"] == null
        ? undefined
        : json["frontConversationId"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceIdentifier:
      json["serviceIdentifier"] == null ? undefined : json["serviceIdentifier"],
    status:
      json["status"] == null
        ? undefined
        : CustomerSpecificPricingAgreementStatusFromJSON(json["status"]),
    accountName: json["accountName"] == null ? undefined : json["accountName"],
    accountNumber:
      json["accountNumber"] == null ? undefined : json["accountNumber"],
    pricingExpiryDate:
      json["pricingExpiryDate"] == null ? undefined : json["pricingExpiryDate"],
    proposalSentDate:
      json["proposalSentDate"] == null ? undefined : json["proposalSentDate"],
    activationDate:
      json["activationDate"] == null ? undefined : json["activationDate"],
    assignedAdmin:
      json["assignedAdmin"] == null ? undefined : json["assignedAdmin"],
    apiToken: json["apiToken"] == null ? undefined : json["apiToken"],
    requiresRateSheet:
      json["requiresRateSheet"] == null ? undefined : json["requiresRateSheet"],
    username: json["username"] == null ? undefined : json["username"],
    password: json["password"] == null ? undefined : json["password"],
    cancellationReason:
      json["cancellationReason"] == null
        ? undefined
        : json["cancellationReason"],
    postalCodeWhitelist:
      json["postalCodeWhitelist"] == null
        ? undefined
        : json["postalCodeWhitelist"],
    carrierTurn:
      json["carrierTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierTurn"]),
    carrierTurnTime:
      json["carrierTurnTime"] == null ? undefined : json["carrierTurnTime"],
    proposalSentAt:
      json["proposalSentAt"] == null ? undefined : json["proposalSentAt"],
    activatedAt: json["activatedAt"] == null ? undefined : json["activatedAt"],
    cancelledAt: json["cancelledAt"] == null ? undefined : json["cancelledAt"],
    draftedAt: json["draftedAt"] == null ? undefined : json["draftedAt"],
    useBlanketRates:
      json["useBlanketRates"] == null ? undefined : json["useBlanketRates"],
    declineReason:
      json["declineReason"] == null ? undefined : json["declineReason"],
    declinedAt: json["declinedAt"] == null ? undefined : json["declinedAt"],
    notes: json["notes"] == null ? undefined : json["notes"],
    existingCustomerAt:
      json["existingCustomerAt"] == null
        ? undefined
        : json["existingCustomerAt"],
    existingCustomerReason:
      json["existingCustomerReason"] == null
        ? undefined
        : json["existingCustomerReason"],
    subAccounts:
      json["subAccounts"] == null
        ? undefined
        : (json["subAccounts"] as Array<any>).map(CspSubAccountFromJSON),
    finalizingAt:
      json["finalizingAt"] == null ? undefined : json["finalizingAt"],
  };
}

export function CustomerSpecificPricingAgreementToJSON(
  json: any,
): CustomerSpecificPricingAgreement {
  return CustomerSpecificPricingAgreementToJSONTyped(json, false);
}

export function CustomerSpecificPricingAgreementToJSONTyped(
  value?: CustomerSpecificPricingAgreement | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerSpecificPricingAgreementId:
      value["customerSpecificPricingAgreementId"],
    createdAt: value["createdAt"],
    companyId: value["companyId"],
    frontConversationId: value["frontConversationId"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    status: CustomerSpecificPricingAgreementStatusToJSON(value["status"]),
    accountName: value["accountName"],
    accountNumber: value["accountNumber"],
    pricingExpiryDate: value["pricingExpiryDate"],
    proposalSentDate: value["proposalSentDate"],
    activationDate: value["activationDate"],
    assignedAdmin: value["assignedAdmin"],
    apiToken: value["apiToken"],
    requiresRateSheet: value["requiresRateSheet"],
    username: value["username"],
    password: value["password"],
    cancellationReason: value["cancellationReason"],
    postalCodeWhitelist: value["postalCodeWhitelist"],
    carrierTurn: ConversationTurnToJSON(value["carrierTurn"]),
    carrierTurnTime: value["carrierTurnTime"],
    proposalSentAt: value["proposalSentAt"],
    activatedAt: value["activatedAt"],
    cancelledAt: value["cancelledAt"],
    draftedAt: value["draftedAt"],
    useBlanketRates: value["useBlanketRates"],
    declineReason: value["declineReason"],
    declinedAt: value["declinedAt"],
    notes: value["notes"],
    existingCustomerAt: value["existingCustomerAt"],
    existingCustomerReason: value["existingCustomerReason"],
    subAccounts:
      value["subAccounts"] == null
        ? undefined
        : (value["subAccounts"] as Array<any>).map(CspSubAccountToJSON),
    finalizingAt: value["finalizingAt"],
  };
}
